<template>
    <div>
        <div class="p-3 my-3 bg-light">
            <strong>通関書類チェック</strong>
        </div>

        <b-row>
            <b-col>
                <b-form-checkbox
                    v-model="value[attribute]"
                    :value="true"
                    :unchecked-value="false"
                    v-for="attribute in [
                        'is_ignitability',
                        'is_food',
                        'is_watch',
                        'is_clock',
                        'is_cosmetic',
                        'is_memory_chip',
                        'is_video_film',
                        'is_radic',
                        'is_power_supply',
                        'is_fda',
                    ]"
                    :key="attribute"
                    >
                    {{ trans.labels['shippings.attributes.' + attribute] }}
                </b-form-checkbox>
            </b-col>
            <b-col>
                <b-form-checkbox
                    v-model="value[attribute]"
                    :value="true"
                    :unchecked-value="false"
                    v-for="attribute in [
                        'is_liquid',
                        'is_footwear',
                        'is_lithium',
                        'is_table',
                    ]"
                    :key="attribute"
                    >
                    {{ trans.labels['shippings.attributes.' + attribute] }}
                </b-form-checkbox>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'
import AddressContent from '@/components/AddressContent.vue'
import LogTable from '@/components/LogTable.vue'

export default {
    components: {
        GridPage,
        FormModal,
        ItemBadges,
        AddressContent,
        LogTable,
        InputError,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'trans',
        ]),
    },
    mounted() {
    },
    destroyed() {
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.shipping-address-th {
    width:0.1%;
    white-space: nowrap;
}
</style>

